import { wc_slicks } from './wc_block_scripts.js';
import { init_variation, init_product_info, insert_extra_products_for_flex, change_variation_image } from './wc-product.js';
import wrap_filters from './wc_product_filters.js';
import quantity_btn_functionality from './wc_product_quantity.js';
import wc_quantity_buttons from './wc_quantity_buttons.js';
import wc_cart from './wc_cart_page.js';
import { change_ship_to_text } from './wc_cart_page.js';
import { block_news } from './wp_block_scripts.js';
import categoryMenu from './wc_category_menu.js';

export default function nsgk_wc() {
  wc_slicks();
  wrap_filters();
  quantity_btn_functionality();
  init_product_info();
  wc_quantity_buttons();
  wc_cart();
  // block_news();
  change_ship_to_text();
  categoryMenu();
  insert_extra_products_for_flex();
  change_variation_image();

  $('.product-add-to-cart .variations tr').each(function(){
    init_variation(this);
  });

  jQuery('.products .price').each(function(){
    jQuery(this).html(jQuery(this).html().replaceAll('&nbsp;', ''));
    jQuery('.woocommerce-Price-currencySymbol', this).before('&nbsp;');
  });

  if ($('body').hasClass('tax-product_cat') || $('body').hasClass('post-type-archive-product')) {
    if ($('.woocommerce-products-header img').length > 0) {
      $('#main').css('padding-top', '340px');
      var image = $('.woocommerce-products-header img').detach();
      $('.woocommerce-products-header > *').wrapAll('<div class="content_wrap"></div>');
      $('.woocommerce-products-header').prepend(image);
    }
  }

  $('.products .product').hover(function(){
    if ($('.woocommerce-loop-product__link img.hover', this).length > 0) {
      $('.woocommerce-loop-product__link img', this).css('display', 'none');
      $('.woocommerce-loop-product__link img.hover', this).css('display', 'block');
    }
  }, function(){
    $('.woocommerce-loop-product__link img', this).css('display', 'block');
    $('.woocommerce-loop-product__link img.hover', this).css('display', 'none');
  });

  $('.woocommerce-loop-product__link').each(function(){
    if ($('span.onsale', this).length) {
      $(this).addClass('has-onsale');
    } else {
      $(this).addClass('not-onsale');
    }
  });

}
